// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:00:23.341Z
// Property: Silver Ridge (ID: 6767906449167256)
// Collections: 13 amenities, 2 floorplans (live), 16 photos, 72 POIs, 4 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167256",
  "property_external_id": "1101842",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/silver-ridge-anchorage-ak/5547z8q/",
  "property_google_business_url": "https://www.google.com/maps/place/Silver+Ridge/data=!4m2!3m1!1s0x0:0x7837eaf70cad664b?sa=X&ved=2ahUKEwjY16f6p4STAxX2BLkGHYh0HNkQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "6341154650",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "silver-ridge",
  "property_name": "Silver Ridge",
  "property_website_url": "https://www.silverridgeapartmenthomes.com/",
  "property_domain": "https://www.silverridgeapartmenthomes.com/",
  "property_address": "1711 Lore Rd",
  "property_full_address": "1711 Lore Rd, Anchorage, AK 99507",
  "property_address_1": "1711 Lore Rd",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99507",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Abbott Loop",
  "property_address_latitude": "61.1523857",
  "property_address_longitude": "-149.8507633",
  "property_email": "silverridge@weidner.com",
  "property_phone": "(907) 308-5505",
  "property_call_tracking_phone": "907-308-5505",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Silver Ridge in Anchorage, AK, where spacious three-bedroom floor plans meet modern living. Enjoy an array of amenities, from a cozy lounge with a gas fireplace to an enticing pet play area. Your ideal home awaits—check availability or schedule a tour to see it for yourself!",
  "property_long_description": "**Welcome to Silver Ridge Apartments in Anchorage, AK!**\n\nDiscover your ideal living space in our spacious three-bedroom apartments, designed for comfort and convenience. Silver Ridge offers a perfect blend of modern amenities and a welcoming community atmosphere. Enjoy the luxury of large closets, double vanities, and in-home washer/dryers that make everyday life easier. Each apartment features a gas fireplace, perfect for cozy evenings, alongside a private patio or balcony to soak up the stunning Alaskan views.\n\nOur community is pet-friendly and boasts a fantastic pet play area, ensuring your furry friends have space to roam and play. Engage with neighbors in our inviting lounge or enjoy the fresh air in our beautifully landscaped courtyard, equipped with picnic areas and a playground for family fun. \n\nSilver Ridge also prioritizes your convenience with online services for payments and service requests, alongside 24-hour emergency maintenance, offering peace of mind every day. Navigate our community easily with elevators and covered walkways, all within a smoke-free environment.\n\nLocated in the heart of Anchorage, Silver Ridge is your gateway to a vibrant lifestyle. Embrace the charm of our community while being close to local shopping, dining, and recreation opportunities.\n\nDon’t miss out on the chance to call Silver Ridge your new home. **Find your new home today—browse our availability or schedule a tour to visit our community!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-909e-7496-bf81-1716612c15ad.webp",
  "property_featured_image_media": {
    "alt_text": "Silver Ridge Apartment Homes exterior building with monument sign and landscaping.",
    "public_id": "01a07554-909e-7496-bf81-1716612c15ad",
    "storage_key": "property/6767906449167256/01a07554-909e-7496-bf81-1716612c15ad.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "60",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.66666666666666",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://silverridgeapartmenthomes.securecafe.com/onlineleasing/silver-ridge-0/floorplans.aspx",
  "property_resident_portal_url": "https://silverridgeapartmenthomes.securecafenet.com/residentservices/silver-ridge-0/userlogin",
  "property_apply_now_url": "https://silverridgeapartmenthomes.securecafe.com/onlineleasing/silver-ridge-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f8150-6535-7379-8188-99441d6469b6.webp",
  "property_primary_logo_media": {
    "alt_text": "Silver Ridge Apartment Homes logo",
    "public_id": "019f8150-6535-7379-8188-99441d6469b6",
    "storage_key": "property/6767906449167256/019f8150-6535-7379-8188-99441d6469b6.webp",
    "width": 225,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f8150-a00a-7074-af19-5fbf9c21dafa.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f8150-a00a-7074-af19-5fbf9c21dafa",
    "storage_key": "property/6767906449167256/019f8150-a00a-7074-af19-5fbf9c21dafa.webp",
    "width": 225,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f8150-9430-71fc-89c8-6bb0da0cdd75.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f8150-9430-71fc-89c8-6bb0da0cdd75",
    "storage_key": "property/6767906449167256/019f8150-9430-71fc-89c8-6bb0da0cdd75.webp",
    "width": 225,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#423B34",
  "property_secondary_color": "#6B6259",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#A89E91",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 950",
  "property_sqft_min": "950",
  "property_sqft_max": "950",
  "property_price_range": "2215 - 2235",
  "property_price_min": "2215",
  "property_price_max": "2235",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/SilverRidgeApartmentHomes",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJsfIr0HyXyFYRS2atDPfqN3g",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Silver Ridge",
  "property_home_romance_title": "Find Your Forever Home and Embrace a Vibrant Community",
  "property_home_amenities_blurb": "Welcome to Silver Ridge in Anchorage, AK—a vibrant community where comfort meets modern living. Our spacious three-bedroom apartments boast luxurious amenities like in-home washers/dryers, large closets, and cozy fireplaces. Enjoy outdoor spaces like our pet-friendly courtyard and picnic area, designed for relaxation and connection. Your ideal home awaits!",
  "property_home_floorplans_blurb": "At Silver Ridge in Anchorage, AK, your ideal living space awaits. Enjoy a harmonious blend of comfort and style in our thoughtfully designed floor plans. Each apartment home reflects modern elegance and cozy charm. Browse our available options today and discover the perfect fit for your lifestyle at Silver Ridge!",
  "property_home_gallery_blurb": "Welcome to Silver Ridge in Anchorage, AK, where comfort meets convenience. Our spacious three-bedroom floor plans feature modern amenities, including large closets, in-home laundry, and a delightful courtyard with a picnic area. Picture yourself enjoying the cozy lounge or relaxing on your private balcony—your perfect home awaits!",
  "property_home_neighborhood_blurb": "Welcome to Silver Ridge, where your ideal Anchorage home awaits! Nestled amid top-rated schools like Polaris K-12 and Service High School, our community offers a vibrant neighborhood experience. Uncover the charm of local parks and educational institutions that enrich your lifestyle. Embrace convenience within reach of your front door!",
  "property_home_reviews_blurb": "Nestled in the heart of Anchorage, Silver Ridge boasts a vibrant community where residents rave about the stunning mountain views and welcoming atmosphere. One resident exclaims, “Living here feels like home!” Dive into our testimonials and see what makes Silver Ridge the perfect place to create lasting memories.",
  "property_neighborhood_blurb": "At Silver Ridge in Anchorage, AK, your family will thrive in a vibrant neighborhood brimming with educational excellence. With top-rated schools like Abbott Loop Elementary and Polaris K-12 nearby, your children's futures are bright. Dive into community life and uncover a world of opportunities right outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Silver Ridge in Anchorage, AK, experience the perfect blend of comfort and convenience. Our spacious three-bedroom apartments feature modern amenities, including a cozy gas fireplace, large closets, and private balconies. Enjoy outdoor fun at our pet play area and picnic spots, complemented by online services for effortless living.",
  "property_applynow_blurb": "Embrace a new lifestyle at Silver Ridge in scenic Anchorage, AK. Our spacious three-bedroom apartments boast large closets, modern kitchens, and relaxing patios. Enjoy unmatched amenities like a pet play area, cozy lounge with fireplace, and a vibrant courtyard—perfect for gatherings. Secure your haven and lease online today!",
  "property_contactus_blurb": "At Silver Ridge in Anchorage, AK, our spacious three-bedroom floor plans are designed for comfort and style. With modern amenities and breathtaking views, you'll feel right at home. Ready to learn more? Reach out to our leasing team today—we're here to answer all your questions!",
  "property_faqs_blurb": "At Silver Ridge in Anchorage, AK, our spacious three-bedroom floor plans offer the ideal blend of comfort and style. With breathtaking views and modern amenities, your perfect home awaits. Curious about our community? Browse our FAQs page for essential insights and find the answers you need to elevate your living experience!",
  "property_floorplans_blurb": "At Silver Ridge in Anchorage, AK, our three-bedroom floor plans offer spacious living with a touch of elegance. Each layout is designed for comfort and style, ideal for families and professionals alike. Browse our available apartment homes to find the perfect floor plan that fits your lifestyle.",
  "property_gallery_blurb": "At Silver Ridge in Anchorage, AK, imagine life in our spacious three-bedroom apartments featuring modern comforts like in-home washers and double vanities. Enjoy peace of mind with 24-hour maintenance and online services while lounging by the fireplace or unwinding in the picturesque courtyard. Picture yourself living here!",
  "property_interactivemap_blurb": "At Silver Ridge in Anchorage, AK, spacious three-bedroom apartments await you. Enjoy modern amenities like an in-home washer/dryer and a cozy gas fireplace, alongside pet-friendly outdoor spaces and a welcoming lounge. Check out our interactive community map to find your ideal home and embrace life at Silver Ridge!",
  "property_pets_blurb": "At Silver Ridge in Anchorage, AK, your furry friends are embraced with open arms! Enjoy spacious living with a welcoming pet policy, perfect for both small and large dogs. With vibrant trails nearby and a cozy community atmosphere, your pets will feel right at home. Join us today!",
  "property_referafriend_blurb": "At Silver Ridge in breathtaking Anchorage, AK, our spacious three-bedroom apartments offer the perfect blend of comfort and style. With stunning views and a welcoming atmosphere, your new home awaits. Share the joy—refer a friend today and create the community you’ve always dreamed of! ",
  "property_residentaccess_blurb": "At Silver Ridge in Anchorage, AK, our spacious three-bedroom floor plans offer the perfect blend of comfort and convenience. Connect with your community through our resident portal, where paying rent and scheduling maintenance is just a click away. Experience the ease of living at Silver Ridge today!",
  "property_reviews_blurb": "At Silver Ridge in Anchorage, AK, residents rave about the “stunning views and vibrant community atmosphere.” Experience the perfect blend of comfort and nature in your new home. Dive into our reviews and see what makes Silver Ridge a cherished choice among our residents!",
  "property_created_at": "1771543914138",
  "property_scheduletour_blurb": "At Silver Ridge in Anchorage, AK, our three-bedroom apartments are designed for comfort and style. With spacious layouts and breathtaking views, each home is a sanctuary. Schedule a tour today and see why our residents cherish the vibrant community life we offer—read their stories and experiences!",
  "property_thankyou_blurb": "Thank you for reaching out to Silver Ridge in Anchorage, AK! Our spacious three-bedroom floor plans offer comfort and style, perfectly designed for modern living. A team member will connect with you shortly to help you find your ideal new home. Get ready to elevate your lifestyle at Silver Ridge!",
  "property_virtualtours_blurb": "At Silver Ridge in beautiful Anchorage, AK, spacious three-bedroom apartments await your discovery. Envision life in our modern layouts, designed for comfort and convenience. Take a virtual tour of our community today and see how our inviting spaces blend perfectly with the stunning Alaskan landscape. Your new home is just a click away!",
  "property_copyright": "2026 All Rights Reserved. Silver Ridge",
  "property_seo_title_home": "Anchorage AK Apartments - Comfort & Community | Silver Ridge",
  "property_seo_description_home": "Find pet-friendly apartments in Anchorage, AK at Silver Ridge. Enjoy in-unit laundry, a dog park, and an inviting community vibe.",
  "property_seo_title_floorplans": "Three Bedroom Floor Plans - Silver Ridge - Anchorage, AK",
  "property_seo_description_floorplans": "Explore three bedroom floor plans at Silver Ridge Apartments in Anchorage, AK. Enjoy gas fireplaces, in-unit laundry, and generous layouts.",
  "property_seo_title_amenities": "Modern Amenities - Silver Ridge Apartments - Anchorage, AK",
  "property_seo_description_amenities": "Experience in-home laundry, gas fireplaces, large closets, and a dog-friendly courtyard at Silver Ridge in Anchorage, AK.",
  "property_seo_title_gallery": "Photo Gallery - Silver Ridge Apartments - Anchorage, AK",
  "property_seo_description_gallery": "View photos of Silver Ridge Apartments in Anchorage, AK - see inviting homes, fireplaces, in-unit laundry, and pet-friendly spaces.",
  "property_seo_title_virtualtours": "Silver Ridge Apartments Virtual Tour - Anchorage, AK",
  "property_seo_description_virtualtours": "Tour Silver Ridge Apartments in Anchorage, AK from anywhere. Explore three-bedroom homes and community ambiance with our convenient virtual option.",
  "property_seo_title_interactivemap": "Interactive Map | Silver Ridge Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Silver Ridge, Anchorage, AK! Enjoy modern amenities, spacious layouts, and a vibrant community. Check our map!",
  "property_seo_title_neighborhood": "Abbott Loop Neighborhood - Silver Ridge - Anchorage, AK",
  "property_seo_description_neighborhood": "Discover Silver Ridge in Anchorage's Abbott Loop - close to Carrs, Dimond Center, Whisper Faith Kovach Playground, and pet parks.",
  "property_seo_title_contact": "Contact Silver Ridge Apartments - Anchorage, AK",
  "property_seo_description_contact": "Connect with Silver Ridge Apartments in Anchorage, AK. Reach out to our leasing team for info about availability, tours, and more.",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Find answers to your questions about Silver Ridge in Anchorage, AK! Discover pet-friendly amenities, spacious floor plans, and excellent online services.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "At Silver Ridge, Anchorage, residents love our spacious homes, pet-friendly amenities, and vibrant community. Check out their reviews!",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Unwind at Silver Ridge in Anchorage, AK—spacious three-bedroom apartments with pet-friendly amenities, cozy fireplaces, and online conveniences. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Silver Ridge",
  "property_seo_description_residentaccess": "Login to Silver Ridge’s resident portal for effortless rent payments, maintenance requests, and more! Your Anchorage home just got even more convenient.",
  "property_seo_title_referafriend": "Refer A Friend | Silver Ridge",
  "property_seo_description_referafriend": "Refer a friend to Silver Ridge in Anchorage, AK—where great friends become great neighbors. Join our vibrant community today and enjoy life together!",
  "property_seo_title_scheduletour": "Schedule a Tour - Silver Ridge Apartments - Anchorage, AK",
  "property_seo_description_scheduletour": "Tour Silver Ridge Apartments in Anchorage, AK your way - choose guided in-person or virtual tours. Explore three-bedroom layouts and pet areas.",
  "property_seo_title_privacy": "Privacy Policy | Silver Ridge",
  "property_seo_description_privacy": "Your privacy matters at Silver Ridge. Discover how we protect your information in Anchorage, AK. View our privacy policy for peace of mind and transparency.",
  "property_seo_title_accessibility": "Website Accessibility | Silver Ridge",
  "property_seo_description_accessibility": "Experience accessible living at Silver Ridge in Anchorage, AK. We're dedicated to ensuring everyone feels at home. Join our inclusive community today!",
  "property_seo_title_sitemap": "Sitemap | Silver Ridge",
  "property_seo_description_sitemap": "Uncover the layout of Silver Ridge in Anchorage, AK! Navigate our sitemap for an easy glimpse into our vibrant community and available amenities.",
  "property_seo_title_thankyou": "Thank You | Silver Ridge",
  "property_seo_description_thankyou": "Thank you for your interest in Silver Ridge! Our team will reach out soon to help you explore the perfect Anchorage apartment tailored to your lifestyle.",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293657754",
  "amenities": [
    {
      "id": "ec_7fd429c784997d3aabc9654b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "87456240",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_263a4222ee24ee5e29d7a723",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "120692108",
      "title": "Covered Walkways",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_411171ee1818efe635b03180",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "120692109",
      "title": "Lobby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0534bdd10b967107771b97ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "120692110",
      "title": "Online Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_130323cc20a12c6da802966f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "120692111",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79b909e5743b1482645d8ad4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "120692112",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00c7a274606d8a548a2c9014",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "124799776",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a817c657e39df229085efcf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "87456252",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7e1be9e6187a74fbcf533d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "87456253",
      "title": "Gas Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65cdc699e6687b45517cf37b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "87456256",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b00c3355f61b99a10d99ab9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "87456257",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_274181a19c488b8d3c6e1e97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "87456258",
      "title": "In-Home Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e157e0324f116f3846ef281",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "yardi",
      "external_id": "120692115",
      "title": "2 Full Bathrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_eadc8c804f37741e12824e3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-909e-7496-bf81-1716612c15ad.webp",
      "image_media": {
        "alt_text": "Silver Ridge Apartment Homes exterior building with monument sign and landscaping.",
        "public_id": "01a07554-909e-7496-bf81-1716612c15ad",
        "storage_key": "property/6767906449167256/01a07554-909e-7496-bf81-1716612c15ad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Silver Ridge Apartment Homes, a beautiful community offering comfortable living spaces. This image showcases the exterior of the building and the prominent monument signage.",
      "link": "false",
      "alt_text": "Silver Ridge Apartment Homes exterior building with monument sign and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (18).jpg"
    },
    {
      "id": "ec_8a9af603caf09f2c9bd867d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-be8c-745d-8812-16e257145ae3.webp",
      "image_media": {
        "alt_text": "Building lobby with fireplace, seating area, plants, and bookshelf.",
        "public_id": "01a07554-be8c-745d-8812-16e257145ae3",
        "storage_key": "property/6767906449167256/01a07554-be8c-745d-8812-16e257145ae3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome guests into the community lobby, featuring a cozy fireplace, comfortable seating, and a well-stocked bookshelf.",
      "link": "false",
      "alt_text": "Building lobby with fireplace, seating area, plants, and bookshelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (17).jpg"
    },
    {
      "id": "ec_4ca735fd41d584dda8291fa5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-aa30-704f-b3f4-315fd82eba34.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, sink, and bathtub with a shower curtain.",
        "public_id": "01a07554-aa30-704f-b3f4-315fd82eba34",
        "storage_key": "property/6767906449167256/01a07554-aa30-704f-b3f4-315fd82eba34.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a sink, toilet, and bathtub with a shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, sink, and bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (16).jpg"
    },
    {
      "id": "ec_241d1ddd3b559eea0a95a8b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-a9d4-7509-814a-431b78c00101.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and balcony access.",
        "public_id": "01a07554-a9d4-7509-814a-431b78c00101",
        "storage_key": "property/6767906449167256/01a07554-a9d4-7509-814a-431b78c00101.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, large windows, and access to a private balcony.",
      "link": "false",
      "alt_text": "Living room with fireplace and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (14).jpg"
    },
    {
      "id": "ec_bffeb1fbbe21fc01ad3f5519",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-aa28-74d4-b8c6-e4fcf2ac05c2.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with fireplace and balcony access",
        "public_id": "01a07554-aa28-74d4-b8c6-e4fcf2ac05c2",
        "storage_key": "property/6767906449167256/01a07554-aa28-74d4-b8c6-e4fcf2ac05c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this efficient kitchen, and relax in the living room featuring a cozy fireplace and access to your private balcony.",
      "link": "false",
      "alt_text": "Kitchen and living area with fireplace and balcony access",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (8).jpg"
    },
    {
      "id": "ec_1063abe7d90e5899841fbd8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-aa35-77b6-b1be-108f11d0c7c8.webp",
      "image_media": {
        "alt_text": "Empty room with carpet, white walls, and a window overlooking the building's exterior.",
        "public_id": "01a07554-aa35-77b6-b1be-108f11d0c7c8",
        "storage_key": "property/6767906449167256/01a07554-aa35-77b6-b1be-108f11d0c7c8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "An empty room featuring plush carpeting, neutral walls, and a window that offers a view of the surrounding building exterior. This space is ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty room with carpet, white walls, and a window overlooking the building's exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (7).jpg"
    },
    {
      "id": "ec_2f624827bcabf0d104c3a578",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-db5f-77e2-a822-c00122ead939.webp",
      "image_media": {
        "alt_text": "Bedroom with large mirrored closet and a ceiling fan.",
        "public_id": "01a07554-db5f-77e2-a822-c00122ead939",
        "storage_key": "property/6767906449167256/01a07554-db5f-77e2-a822-c00122ead939.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large mirrored closet for ample storage and a modern ceiling fan for comfort.",
      "link": "false",
      "alt_text": "Bedroom with large mirrored closet and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (11).jpg"
    },
    {
      "id": "ec_3a22a723b57fdc735748ad8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-dd60-7757-9b48-22460f3cf70c.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a door leading outside.",
        "public_id": "01a07554-dd60-7757-9b48-22460f3cf70c",
        "storage_key": "property/6767906449167256/01a07554-dd60-7757-9b48-22460f3cf70c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, plush carpeting, and a private door to the outdoors. Perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Living room with a fireplace and a door leading outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (5).jpg"
    },
    {
      "id": "ec_66fccafcbaaee7297bcde8ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-dbce-71e9-ab1c-63b1d02bd13d.webp",
      "image_media": {
        "alt_text": "Bedroom view of apartment with doorway to kitchen and bathroom",
        "public_id": "01a07554-dbce-71e9-ab1c-63b1d02bd13d",
        "storage_key": "property/6767906449167256/01a07554-dbce-71e9-ab1c-63b1d02bd13d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom with plush carpeting, featuring access to a kitchen area and a private bathroom.",
      "link": "false",
      "alt_text": "Bedroom view of apartment with doorway to kitchen and bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (12).jpg"
    },
    {
      "id": "ec_e06527cc0b4fe09e2ef4e129",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-e086-72bc-8a0f-1fc513f2e2f1.webp",
      "image_media": {
        "alt_text": "White kitchen with a double sink, dishwasher, stove, and refrigerator.",
        "public_id": "01a07554-e086-72bc-8a0f-1fc513f2e2f1",
        "storage_key": "property/6767906449167256/01a07554-e086-72bc-8a0f-1fc513f2e2f1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinetry, a double sink, dishwasher, stove, and a refrigerator, perfect for all your culinary needs.",
      "link": "false",
      "alt_text": "White kitchen with a double sink, dishwasher, stove, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (9).jpg"
    },
    {
      "id": "ec_5e4a6f96689819f334a99483",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07554-f2cb-73cf-8ae0-bc818a862b0d.webp",
      "image_media": {
        "alt_text": "Open concept living space and kitchen with view of laundry area.",
        "public_id": "01a07554-f2cb-73cf-8ae0-bc818a862b0d",
        "storage_key": "property/6767906449167256/01a07554-f2cb-73cf-8ae0-bc818a862b0d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area with a view into the kitchen and a dedicated laundry nook.",
      "link": "false",
      "alt_text": "Open concept living space and kitchen with view of laundry area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (6).jpg"
    },
    {
      "id": "ec_6a29e6ecd74a5c8a31776b84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07555-0286-743a-8c95-4f61f221154b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with courtyard and stairs",
        "public_id": "01a07555-0286-743a-8c95-4f61f221154b",
        "storage_key": "property/6767906449167256/01a07555-0286-743a-8c95-4f61f221154b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing the courtyard, walkways, and balconies.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with courtyard and stairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (15).jpg"
    },
    {
      "id": "ec_7d309409f51f2c98ba9f9721",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07555-22e2-712f-82bf-cac1cbb2ef24.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and balcony door, adjacent to a kitchen.",
        "public_id": "01a07555-22e2-712f-82bf-cac1cbb2ef24",
        "storage_key": "property/6767906449167256/01a07555-22e2-712f-82bf-cac1cbb2ef24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace and access to a private balcony, seamlessly connected to a functional kitchen.",
      "link": "false",
      "alt_text": "Living room with a fireplace and balcony door, adjacent to a kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (10).jpg"
    },
    {
      "id": "ec_dfb25deb8bb2556efb3e7bf3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07555-0d71-722c-ad9b-e35ea4759ccf.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, white cabinets, and wood accents.",
        "public_id": "01a07555-0d71-722c-ad9b-e35ea4759ccf",
        "storage_key": "property/6767906449167256/01a07555-0d71-722c-ad9b-e35ea4759ccf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A compact kitchen featuring white appliances including a refrigerator, oven, and dishwasher, complemented by white cabinetry and a double sink. Ideal for efficient living.",
      "link": "false",
      "alt_text": "Kitchen with white appliances, white cabinets, and wood accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (4).jpg"
    },
    {
      "id": "ec_f7a61d14d3048ddf116ad2f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07555-0e2d-7478-9fda-efc687731ed6.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with laundry closet and hallway with doors.",
        "public_id": "01a07555-0e2d-7478-9fda-efc687731ed6",
        "storage_key": "property/6767906449167256/01a07555-0e2d-7478-9fda-efc687731ed6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located in a laundry closet, offering easy access to your apartment.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with laundry closet and hallway with doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (13).jpg"
    },
    {
      "id": "ec_2748f2078a2419d0c5eeb42b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/01a07555-0ddc-7568-8f7b-ea9b2e1c39e4.webp",
      "image_media": {
        "alt_text": "Living room with kitchen view and modern furniture",
        "public_id": "01a07555-0ddc-7568-8f7b-ea9b2e1c39e4",
        "storage_key": "property/6767906449167256/01a07555-0ddc-7568-8f7b-ea9b2e1c39e4.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a large TV, comfortable sofa, and a modern kitchen area visible through an open pass-through.",
      "link": "false",
      "alt_text": "Living room with kitchen view and modern furniture",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Silver_Ridge_Favorites (2).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_80e5c37a-b384-47e2-9470-64434560df5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Barbie's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6728 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Diner-style restaurant serving homestyle American dishes such as omelettes, chicken-fried steak, and pancakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-37f1-7170-ab08-3858d909d385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-37f1-7170-ab08-3858d909d385",
        "storage_key": "property/6767906449167256/019f3e9f-37f1-7170-ab08-3858d909d385.webp",
        "width": 1041,
        "height": 885
      },
      "poi_business_url": "http://www.barbiescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=81934120336670855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barbies-cafe",
      "poi_latitude": "61.15973899999999",
      "poi_longitude": "-149.8351172",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-344-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YgesG-XyFYRh8Cm-aUWIwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_67336a6d-8194-48d5-acf1-3065fcd89bd0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Rae Rae's Coffee Shop",
      "poi_type": "Restaurants",
      "poi_address": "11321 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-3c47-70a9-bdd6-b098f0dca703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-3c47-70a9-bdd6-b098f0dca703",
        "storage_key": "property/6767906449167256/019f3e9f-3c47-70a9-bdd6-b098f0dca703.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2118273492644830845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rae-raes-coffee-shop",
      "poi_latitude": "61.11834940000001",
      "poi_longitude": "-149.8631059",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8w0ngOXyFYRfZ44uoSeZR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_stand"
    },
    {
      "id": "custom_57f15caf-ce30-4fcf-95e0-422663aaf626",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Seward's Folly Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1811 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Alaskan comfort food & beer served in a relaxed setting with sports on TV & a patio.",
      "poi_long_description": "Alaskan comfort food & beer served in a relaxed setting with sports on TV & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-37f1-7170-ab08-3c9e8483a867.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-37f1-7170-ab08-3c9e8483a867",
        "storage_key": "property/6767906449167256/019f3e9f-37f1-7170-ab08-3c9e8483a867.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sewardsfollybarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4051999169264824643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sewards-folly-bar--grill",
      "poi_latitude": "61.1407099",
      "poi_longitude": "-149.8466137",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-222-1218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZK6gt6ZyFYRQzE1qsaXOzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e4f584eb-f768-4732-b0d2-333e1d0d2e7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Lahn Pad Thai",
      "poi_type": "Restaurants",
      "poi_address": "2101 Abbott Rd #7, Anchorage, AK 99507, USA",
      "poi_short_description": "Cozy family-owned standby for Thai dishes spiced to order, with fixed-price lunch deals & delivery.",
      "poi_long_description": "Cozy family-owned standby for Thai dishes spiced to order, with fixed-price lunch deals & delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-381d-708c-b983-c5080797e48d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-381d-708c-b983-c5080797e48d",
        "storage_key": "property/6767906449167256/019f3e9f-381d-708c-b983-c5080797e48d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lptak.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4059606731220113285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lahn-pad-thai",
      "poi_latitude": "61.138298",
      "poi_longitude": "-149.843428",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-272-8424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbZO2d2ZyFYRhdcoNtCeVjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_ed031edf-0e02-47b2-9878-490a38b8978e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Flying Dutchman European Pastry Shop",
      "poi_type": "Restaurants",
      "poi_address": "2101 Abbott Rd #9, Anchorage, AK 99507, USA",
      "poi_short_description": "European-style bakery offering cakes, pies, pastries, cookies and chocolates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-3ac5-74c9-96ed-f8953ce47265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-3ac5-74c9-96ed-f8953ce47265",
        "storage_key": "property/6767906449167256/019f3e9f-3ac5-74c9-96ed-f8953ce47265.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.ravenchocolates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9388391438492704739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-dutchman-european-pastry-shop",
      "poi_latitude": "61.1381695",
      "poi_longitude": "-149.8433737",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-1072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbZO2d2ZyFYR4x-tf0VESoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_67f36bc1-af75-4be4-9d76-61e65be85080",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Lalo's Pizza Take Out",
      "poi_type": "Restaurants",
      "poi_address": "5915 Lake Otis Pkwy #6, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-3d6d-762e-a0cc-8cf7df86f491.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-3d6d-762e-a0cc-8cf7df86f491",
        "storage_key": "property/6767906449167256/019f3e9f-3d6d-762e-a0cc-8cf7df86f491.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9646638834980904580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lalos-pizza-take-out",
      "poi_latitude": "61.1672331",
      "poi_longitude": "-149.8363495",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-375-9723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4b1VBnOXyFYRhF6GC-m-34U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8624300b-48bb-4a7e-af9a-eae8ec172007",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Little Italy Restaurante",
      "poi_type": "Restaurants",
      "poi_address": "2300 E 88th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "Pizza & traditional Italian dishes join Greek fare in a convivial, family-run restaurant with a bar.",
      "poi_long_description": "Pizza & traditional Italian dishes join Greek fare in a convivial, family-run restaurant with a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-3d17-77e7-b3b0-38899abf5ab8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-3d17-77e7-b3b0-38899abf5ab8",
        "storage_key": "property/6767906449167256/019f3e9f-3d17-77e7-b3b0-38899abf5ab8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.littleitalyrestaurante.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17938592807094397304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-italy-restaurante",
      "poi_latitude": "61.1407512",
      "poi_longitude": "-149.8391419",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-344-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwc9KId6ZyFYReCk9hR2v8vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_93d8e45f-b869-4a36-828b-0b6eecd887eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Long Branch Saloon",
      "poi_type": "Restaurants",
      "poi_address": "1737 E Dimond Blvd, Anchorage, AK 99507, USA",
      "poi_short_description": "Unfussy bar and grill offering quick bites and live entertainment, plus pool tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-3a46-732d-a91c-c93cab2b98a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-3a46-732d-a91c-c93cab2b98a2",
        "storage_key": "property/6767906449167256/019f3e9f-3a46-732d-a91c-c93cab2b98a2.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://longbranchsaloon.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12515263135807042389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "long-branch-saloon",
      "poi_latitude": "61.1450991",
      "poi_longitude": "-149.8493952",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-349-4142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz9sF59iZyFYRVfNRaIMlr60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_4537208f-4c43-4b39-a6ef-9c2952df5500",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Kaladi Brothers Coffee",
      "poi_type": "Restaurants",
      "poi_address": "6901 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Coffeehouse chain offering hot & cold brews made with air-roasted beans in a hip space.",
      "poi_long_description": "Coffeehouse chain offering hot & cold brews made with air-roasted beans in a hip space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-3aaa-743b-b16f-3b9dbf39d90a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-3aaa-743b-b16f-3b9dbf39d90a",
        "storage_key": "property/6767906449167256/019f3e9f-3aaa-743b-b16f-3b9dbf39d90a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kaladi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9353179456527323873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaladi-brothers-coffee",
      "poi_latitude": "61.1813972",
      "poi_longitude": "-149.7514722",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-337-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ae9-73b9-bcb1-906ed7d09689.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ae9-73b9-bcb1-906ed7d09689",
        "storage_key": "property/6767906449167256/019d022a-2ae9-73b9-bcb1-906ed7d09689.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJaft2O9eWyFYR4dLKEikrzYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_377ae88f-c422-4098-b32d-10039d860e0c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "South Restaurant + Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "11124 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Urban-chic spot offering a combination of New American dining with a bar, coffee cafe & kids' fare.",
      "poi_long_description": "Urban-chic spot offering a combination of New American dining with a bar, coffee cafe & kids' fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-37fc-71e3-94b0-27e97a38f9d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-37fc-71e3-94b0-27e97a38f9d4",
        "storage_key": "property/6767906449167256/019f3e9f-37fc-71e3-94b0-27e97a38f9d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.southak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1369574684574852737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-restaurant--coffeehouse",
      "poi_latitude": "61.1199527",
      "poi_longitude": "-149.8678209",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-770-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9HO7JWZyFYRgaZzV-u0ARM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ff3f3e44-bb57-45b7-8ae5-7f291ce044a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9c-f778-7680-b158-14e660c7107c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9c-f778-7680-b158-14e660c7107c",
        "storage_key": "property/6767906449167256/019f3e9c-f778-7680-b158-14e660c7107c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.8691037",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3eac0dea-195d-4a65-8004-b9700392d0d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Don Jose's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2052 E Northern Lights Blvd, Anchorage, AK 99508, USA",
      "poi_short_description": "Upbeat eatery & cantina offering familiar Mexican food such as fajitas, burritos & enchiladas.",
      "poi_long_description": "Upbeat eatery & cantina offering familiar Mexican food such as fajitas, burritos & enchiladas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-408a-7776-94ac-b34cf7129937.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-408a-7776-94ac-b34cf7129937",
        "storage_key": "property/6767906449167256/019f3e9f-408a-7776-94ac-b34cf7129937.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskadonjoses.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4159488084211947592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-joses-mexican-restaurant",
      "poi_latitude": "61.1950028",
      "poi_longitude": "-149.8419563",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-279-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcDwQqKWyFYRSFjs6l94uTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_63736562-cca1-49bd-a231-3f532bab0366",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Spenard Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1049 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_long_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9c-f708-7364-994d-1b9d78edb3b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9c-f708-7364-994d-1b9d78edb3b0",
        "storage_key": "property/6767906449167256/019f3e9c-f708-7364-994d-1b9d78edb3b0.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.spenardroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079478686688268729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-roadhouse",
      "poi_latitude": "61.19552819999999",
      "poi_longitude": "-149.9032167",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-770-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAGpNuXyFYRudEsUXaA4Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f02dbb8c-ec54-47dc-b6b9-2090dcf82ea1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Lucky Wishbone",
      "poi_type": "Restaurants",
      "poi_address": "1033 E 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Venerable spot specializing in fried chicken that also offers burgers & old-school milkshakes.",
      "poi_long_description": "Venerable spot specializing in fried chicken that also offers burgers & old-school milkshakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-3fd7-714e-b721-cdf0a20a6504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-3fd7-714e-b721-cdf0a20a6504",
        "storage_key": "property/6767906449167256/019f3e9f-3fd7-714e-b721-cdf0a20a6504.webp",
        "width": 505,
        "height": 510
      },
      "poi_business_url": "https://www.luckywishbonealaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13620763451261645908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-wishbone",
      "poi_latitude": "61.2178566",
      "poi_longitude": "-149.8633984",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-272-3454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1coxDqWyFYRVPQSajGsBr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_b41ed447-ffb8-4ef9-b4e1-957174558eba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Harley's Old Thyme Cafe",
      "poi_type": "Restaurants",
      "poi_address": "7550 Old Seward Hwy, Anchorage, AK 99518, USA",
      "poi_short_description": "Family-run eatery for classic breakfasts & down-home fare, including chicken-fried steak & catfish.",
      "poi_long_description": "Family-run eatery for classic breakfasts & down-home fare, including chicken-fried steak & catfish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-421f-756b-9bc8-e597858e520c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-421f-756b-9bc8-e597858e520c",
        "storage_key": "property/6767906449167256/019f3e9f-421f-756b-9bc8-e597858e520c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://harleysotcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11799786668834197692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harleys-old-thyme-cafe",
      "poi_latitude": "61.1524223",
      "poi_longitude": "-149.8647748",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-349-8878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2614-72ab-8f86-dcb4af0326e5",
        "storage_key": "property/6767906449167256/019d022a-2614-72ab-8f86-dcb4af0326e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_n5D36XyFYRvJBAFXVDwaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5f873887-c3a5-43c0-b06e-34f0fb594b48",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "1725 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-4162-7471-a505-2223c2e89e81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-4162-7471-a505-2223c2e89e81",
        "storage_key": "property/6767906449167256/019f3e9f-4162-7471-a505-2223c2e89e81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/1725-abbott-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968100458918547655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.14205939999999",
      "poi_longitude": "-149.8440099",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-339-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ae9-73b9-bcb1-961cac163a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ae9-73b9-bcb1-961cac163a47",
        "storage_key": "property/6767906449167256/019d022a-2ae9-73b9-bcb1-961cac163a47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVcl7t6ZyFYRx5AzIBBguc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3ae167ca-7189-4d1a-918f-ff79842c5e88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9c-fcde-7268-9d57-7785228c21f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9c-fcde-7268-9d57-7785228c21f2",
        "storage_key": "property/6767906449167256/019f3e9c-fcde-7268-9d57-7785228c21f2.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/southeast-anchorage/701/00656?cid=loc_70100656_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7143625480901027585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.1358972",
      "poi_longitude": "-149.8390961",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-365-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ae9-73b9-bcb1-961cac163a47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ae9-73b9-bcb1-961cac163a47",
        "storage_key": "property/6767906449167256/019d022a-2ae9-73b9-bcb1-961cac163a47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQGYP-eZyFYRAeeIvYZBI2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_10755761-88f8-4e1c-bcda-f95056069d2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1501 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_long_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-4439-74fe-9e5b-89c919644232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-4439-74fe-9e5b-89c919644232",
        "storage_key": "property/6767906449167256/019f3e9f-4439-74fe-9e5b-89c919644232.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/1501-abbott-rd/2746606?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8673908847225693236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.145096",
      "poi_longitude": "-149.8537893",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-349-2847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2c7d-72c5-b70c-9cbfafbbf73e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2c7d-72c5-b70c-9cbfafbbf73e",
        "storage_key": "property/6767906449167256/019d022a-2c7d-72c5-b70c-9cbfafbbf73e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJfxUdrtmZyFYRNGQB5SPqX3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_adf209b3-41af-49a7-95b3-8aebce268613",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "7 Star Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "916 Ingra St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-43b2-7646-968e-aa77fb61ce4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-43b2-7646-968e-aa77fb61ce4b",
        "storage_key": "property/6767906449167256/019f3e9f-43b2-7646-968e-aa77fb61ce4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4336394223482193283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-star-food-mart",
      "poi_latitude": "61.21347170000001",
      "poi_longitude": "-149.8676303",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-770-0329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2c7d-72c5-b70c-9cbfafbbf73e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2c7d-72c5-b70c-9cbfafbbf73e",
        "storage_key": "property/6767906449167256/019d022a-2c7d-72c5-b70c-9cbfafbbf73e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJefO2TDCWyFYRg0W2MJL3LTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7c6052ef-7129-49b4-8fba-8d99a622beaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2550 E 88th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-4bdd-7258-80c0-69264a2205d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-4bdd-7258-80c0-69264a2205d5",
        "storage_key": "property/6767906449167256/019f3e9f-4bdd-7258-80c0-69264a2205d5.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2550+e+88th+ave-anchorage-ak-99507/id=15654",
      "poi_directions_map_url": "https://maps.google.com/?cid=1876399245557480173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1405919",
      "poi_longitude": "-149.8352217",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-349-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswTnYeCZyFYR7bpDGCxPCho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_9085f8ef-383d-41ec-8075-c38e6fc8db09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Dimond Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 E Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_long_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9c-fce4-715b-97ab-412ed6fe026c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9c-fce4-715b-97ab-412ed6fe026c",
        "storage_key": "property/6767906449167256/019f3e9c-fce4-715b-97ab-412ed6fe026c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dimondcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335366531638308692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-center",
      "poi_latitude": "61.1438157",
      "poi_longitude": "-149.8691231",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-344-2581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2b68-76c2-98d1-c4790e21b60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2b68-76c2-98d1-c4790e21b60d",
        "storage_key": "property/6767906449167256/019d022a-2b68-76c2-98d1-c4790e21b60d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRVC8_E8ksiBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1fb35c03-8c5c-4bf8-a567-2d21eb05f51c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Tikahtnu Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "1142 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Shopping complex with a movie theater and a game store, plus a Starbucks and chain retailers such as Target.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-44e4-745c-b9dd-07d7d04ddd85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-44e4-745c-b9dd-07d7d04ddd85",
        "storage_key": "property/6767906449167256/019f3e9f-44e4-745c-b9dd-07d7d04ddd85.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tikahtnucommons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4413898816297472885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tikahtnu-commons",
      "poi_latitude": "61.23079939999999",
      "poi_longitude": "-149.7389775",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2b68-76c2-98d1-c4790e21b60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2b68-76c2-98d1-c4790e21b60d",
        "storage_key": "property/6767906449167256/019d022a-2b68-76c2-98d1-c4790e21b60d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8dy9OSaUyFYRdZPta5ZRQT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_888a1fd4-cb5a-4781-8c61-dda7dddcde39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Brown Jug Independence Park - #226",
      "poi_type": "Shopping & Retail",
      "poi_address": "2101 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-46f4-75bb-9fb0-edcbb27ef861.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-46f4-75bb-9fb0-edcbb27ef861",
        "storage_key": "property/6767906449167256/019f3e9f-46f4-75bb-9fb0-edcbb27ef861.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "http://www.brownjugalaska.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17648077747081045796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brown-jug-independence-park---226",
      "poi_latitude": "61.13833330000001",
      "poi_longitude": "-149.8432729",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-349-6324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2b68-76c2-98d1-c4790e21b60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2b68-76c2-98d1-c4790e21b60d",
        "storage_key": "property/6767906449167256/019d022a-2b68-76c2-98d1-c4790e21b60d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhaVoem-XyFYRJOc9GzWR6vQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_4e4f34f4-6924-458d-a814-d424ad184aa9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Abbott Loop Elementary School",
      "poi_type": "Education",
      "poi_address": "8427 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-46dd-72fe-a9df-3a9d9f0dbdb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-46dd-72fe-a9df-3a9d9f0dbdb7",
        "storage_key": "property/6767906449167256/019f3e9f-46dd-72fe-a9df-3a9d9f0dbdb7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/abbottloop",
      "poi_directions_map_url": "https://maps.google.com/?cid=688732736260866008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abbott-loop-elementary-school",
      "poi_latitude": "61.1439499",
      "poi_longitude": "-149.8331466",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE8yU9l-XyFYR2P8CSsbejgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_784a7efc-e162-4455-986a-8b815d6a26d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Hanshew Middle School",
      "poi_type": "Education",
      "poi_address": "10121 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/hanshew",
      "poi_directions_map_url": "https://maps.google.com/?cid=10663501361446957486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hanshew-middle-school",
      "poi_latitude": "61.13046050000001",
      "poi_longitude": "-149.8308",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-742-9930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz1jDgO-ZyFYRrrHwlv1d_JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a38958b6-967d-4f9c-a38f-59a91e729694",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Service High School",
      "poi_type": "Education",
      "poi_address": "5577 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-042a-75c6-aa6c-93ec302c39c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-042a-75c6-aa6c-93ec302c39c5",
        "storage_key": "property/6767906449167256/019d022a-042a-75c6-aa6c-93ec302c39c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/service",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278618715163057178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "service-high-school",
      "poi_latitude": "61.13819179999999",
      "poi_longitude": "-149.7813215",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-742-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv9DYX6yQyFYRGtzBoapqZqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0fedcb3d-3761-4de5-82b1-158353c250e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Polaris K-12 School",
      "poi_type": "Education",
      "poi_address": "6200 Ashwood St, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-05b8-734e-b528-c39ca8e9f277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-05b8-734e-b528-c39ca8e9f277",
        "storage_key": "property/6767906449167256/019d022a-05b8-734e-b528-c39ca8e9f277.webp",
        "width": 1032,
        "height": 581
      },
      "poi_business_url": "http://polaris.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18212036476561568338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "polaris-k-12-school",
      "poi_latitude": "61.16447830000001",
      "poi_longitude": "-149.8538648",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmQMbsneXyFYRUrLoFa8mvvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_98175250-f0e1-4171-bde2-5aa4dd09df72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Pacific Northern Academy",
      "poi_type": "Education",
      "poi_address": "2511 Sentry Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pacificnorthern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206734834740584442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-northern-academy",
      "poi_latitude": "61.1333745",
      "poi_longitude": "-149.8356213",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW969xGeWyFYR-l9pozx43gI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_77720647-37cb-4657-9f6d-fd578b28feae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Lothem Preschool",
      "poi_type": "Education",
      "poi_address": "1716 E 58th Cir, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-4b82-73c0-aafa-9dc7d03c6c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-4b82-73c0-aafa-9dc7d03c6c7e",
        "storage_key": "property/6767906449167256/019f3e9f-4b82-73c0-aafa-9dc7d03c6c7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lothempreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12065094339377665180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lothem-preschool",
      "poi_latitude": "61.1680715",
      "poi_longitude": "-149.8499857",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-240-9855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs6G0I2yXyFYRnJQuyGDTb6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_fc13d131-0c9a-4395-8af7-a14e58e1b23c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Bright Beginnings Early Learning Center",
      "poi_type": "Education",
      "poi_address": "2500 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-09f0-70e1-93d2-bad99877a5d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-09f0-70e1-93d2-bad99877a5d9",
        "storage_key": "property/6767906449167256/019d022a-09f0-70e1-93d2-bad99877a5d9.webp",
        "width": 1280,
        "height": 583
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8792655671257846223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-beginnings-early-learning-center",
      "poi_latitude": "61.13716770000001",
      "poi_longitude": "-149.835934",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-341-1201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnz9q2uaZyFYRz9GlXb_JBXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_ab09a1c7-e13d-4159-bc5c-eff305dba986",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-0a42-700d-9c25-6227c13e9486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-0a42-700d-9c25-6227c13e9486",
        "storage_key": "property/6767906449167256/019f3e9d-0a42-700d-9c25-6227c13e9486.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_78172512-b5a4-4af6-9c44-f51f7547ee65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Pacific University",
      "poi_type": "Education",
      "poi_address": "4101 University Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-48ab-765b-8e4b-c3475967ee66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-48ab-765b-8e4b-c3475967ee66",
        "storage_key": "property/6767906449167256/019f3e9f-48ab-765b-8e4b-c3475967ee66.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.alaskapacific.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603594146335186940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-pacific-university",
      "poi_latitude": "61.1892616",
      "poi_longitude": "-149.8065058",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-252-7528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsU8plvyWyFYR_F8cymU_CKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c7d73b33-16cf-48e3-aac4-7d39d6edf6df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska State School For Deaf",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/AKSDHH/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10801339263008404762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-state-school-for-deaf",
      "poi_latitude": "61.19412589999999",
      "poi_longitude": "-149.7756013",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWxp_nOiWyFYRGnUY7tQQ5pU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f41f0e57-02c8-4c32-b09b-75f16d54753a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "H2Oasis Indoor Waterpark",
      "poi_type": "Entertainment",
      "poi_address": "1520 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Guests can drift in the lazy river circling the park, speed down slides or bob in the wave pool.",
      "poi_long_description": "Guests can drift in the lazy river circling the park, speed down slides or bob in the wave pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-4ca1-751b-b095-6f41bf380d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-4ca1-751b-b095-6f41bf380d74",
        "storage_key": "property/6767906449167256/019f3e9f-4ca1-751b-b095-6f41bf380d74.webp",
        "width": 1280,
        "height": 798
      },
      "poi_business_url": "http://www.h2oasiswaterpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17244752553518220645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h2oasis-indoor-waterpark",
      "poi_latitude": "61.12095840000001",
      "poi_longitude": "-149.8537473",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-522-4420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3HMyZSZyFYRZcX2rxSrUe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_8d385fda-ab08-4962-b86d-8adc99b0328d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-0c9b-7049-950b-aa6cea1b6cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-0c9b-7049-950b-aa6cea1b6cb7",
        "storage_key": "property/6767906449167256/019f3e9d-0c9b-7049-950b-aa6cea1b6cb7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_82c9aa0d-f99e-469c-ac87-82d58d0acde3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Museum of Science and Nature",
      "poi_type": "Entertainment",
      "poi_address": "201 N Bragaw St, Anchorage, AK 99508, USA",
      "poi_short_description": "Museum exploring Alaska's natural history, with dinosaur fossils & hands-on displays for kids.",
      "poi_long_description": "Museum exploring Alaska's natural history, with dinosaur fossils & hands-on displays for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-4d27-7365-b70e-2c93be667e53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-4d27-7365-b70e-2c93be667e53",
        "storage_key": "property/6767906449167256/019f3e9f-4d27-7365-b70e-2c93be667e53.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://www.alaskamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16255560840695787410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-museum-of-science-and-nature",
      "poi_latitude": "61.22514929999999",
      "poi_longitude": "-149.8078589",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-274-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2fe8-76ec-9d27-fb186a1dc353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2fe8-76ec-9d27-fb186a1dc353",
        "storage_key": "property/6767906449167256/019d022a-2fe8-76ec-9d27-fb186a1dc353.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99EwrG-WyFYRki9sfnVal-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8f8e9d43-d0ea-4889-8307-d8c94c4fe3b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-0b6f-71c7-984e-6a0e222fdf28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-0b6f-71c7-984e-6a0e222fdf28",
        "storage_key": "property/6767906449167256/019f3e9d-0b6f-71c7-984e-6a0e222fdf28.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2fe8-76ec-9d27-fb186a1dc353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2fe8-76ec-9d27-fb186a1dc353",
        "storage_key": "property/6767906449167256/019d022a-2fe8-76ec-9d27-fb186a1dc353.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_956f21fa-eead-4b10-abd0-acad5b918a49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-0f57-763d-bdbe-74caf18c836f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-0f57-763d-bdbe-74caf18c836f",
        "storage_key": "property/6767906449167256/019d022a-0f57-763d-bdbe-74caf18c836f.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_a627f843-a7a1-4f95-8ff4-0357d7d91979",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-1042-71b8-a251-25ab684846cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-1042-71b8-a251-25ab684846cd",
        "storage_key": "property/6767906449167256/019d022a-1042-71b8-a251-25ab684846cd.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0862fd54-dd43-454a-a1aa-55e2db92dc06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Sullivan Arena",
      "poi_type": "Entertainment",
      "poi_address": "1600 Gambell St, Anchorage, AK 99501, USA",
      "poi_short_description": "Huge multi-use facility that hosts hockey & basketball games, rock concerts & trade shows.",
      "poi_long_description": "Huge multi-use facility that hosts hockey & basketball games, rock concerts & trade shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-0e8c-7234-8bfb-c57caba2d747.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-0e8c-7234-8bfb-c57caba2d747",
        "storage_key": "property/6767906449167256/019f3e9d-0e8c-7234-8bfb-c57caba2d747.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thesullivanarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523528862628190629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivan-arena",
      "poi_latitude": "61.2058827",
      "poi_longitude": "-149.8732523",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-868-4314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAADyWyFYRpRmeDrryQwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_4a9d9549-e251-4a48-8912-8cc0c02371cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-508d-7094-8e5b-5c269a658509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-508d-7094-8e5b-5c269a658509",
        "storage_key": "property/6767906449167256/019f3e9f-508d-7094-8e5b-5c269a658509.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2639-7545-b48b-d52c65c421bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2639-7545-b48b-d52c65c421bf",
        "storage_key": "property/6767906449167256/019d022a-2639-7545-b48b-d52c65c421bf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_7fa45991-64e9-4236-b6c3-4e0f7f4284d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Chilkoot Charlie's",
      "poi_type": "Entertainment",
      "poi_address": "2435 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Huge nightclub with 3 stages, 3 dance floors & 10 bars that hosts DJs, comedians & live music.",
      "poi_long_description": "Huge nightclub with 3 stages, 3 dance floors & 10 bars that hosts DJs, comedians & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-51b6-70c7-ab8c-bd48304d6519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-51b6-70c7-ab8c-bd48304d6519",
        "storage_key": "property/6767906449167256/019f3e9f-51b6-70c7-ab8c-bd48304d6519.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.koots.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363898658339064900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilkoot-charlies",
      "poi_latitude": "61.19817330000001",
      "poi_longitude": "-149.9049457",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-272-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-27fe-747e-bbd8-89f948700819.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-27fe-747e-bbd8-89f948700819",
        "storage_key": "property/6767906449167256/019d022a-27fe-747e-bbd8-89f948700819.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwUxINqXyFYRRIxyYuv2048",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "night_club"
    },
    {
      "id": "custom_adbdfb69-c1df-4bef-976a-085e78271546",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "The Nave",
      "poi_type": "Entertainment",
      "poi_address": "3502 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-548a-77dc-9b7d-f4c3a30c8dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-548a-77dc-9b7d-f4c3a30c8dc0",
        "storage_key": "property/6767906449167256/019f3e9f-548a-77dc-9b7d-f4c3a30c8dc0.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://thenavespenard.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14373816960398302156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nave",
      "poi_latitude": "61.18881330000001",
      "poi_longitude": "-149.9091318",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-227-5244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQunNJ6XyFYRzJsGp14Oesc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_8750f50c-5a35-450d-bfef-b163a3a2ede9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-1905-76a6-92b7-9421f3165fd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-1905-76a6-92b7-9421f3165fd3",
        "storage_key": "property/6767906449167256/019f3e9d-1905-76a6-92b7-9421f3165fd3.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.8221354",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-3199-758d-bb41-f740a2e3b52f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-3199-758d-bb41-f740a2e3b52f",
        "storage_key": "property/6767906449167256/019d022a-3199-758d-bb41-f740a2e3b52f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_40ffb279-b768-4df0-b024-901e9cb7404e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-140a-71ca-9ef0-5f5a529f712a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-140a-71ca-9ef0-5f5a529f712a",
        "storage_key": "property/6767906449167256/019d022a-140a-71ca-9ef0-5f5a529f712a.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2106829",
      "poi_longitude": "-149.8283619",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-3199-758d-bb41-f740a2e3b52f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-3199-758d-bb41-f740a2e3b52f",
        "storage_key": "property/6767906449167256/019d022a-3199-758d-bb41-f740a2e3b52f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fb51202a-3da4-4830-98f7-9891ebbae723",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alpine Urgent Care & Sports Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "1310 E Dimond Blvd #1, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-5106-722b-a01f-462c71f02880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-5106-722b-a01f-462c71f02880",
        "storage_key": "property/6767906449167256/019f3e9f-5106-722b-a01f-462c71f02880.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://alpineurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=41279430031882753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alpine-urgent-care--sports-medicine",
      "poi_latitude": "61.14409449999999",
      "poi_longitude": "-149.8583741",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-344-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYdk8dmZyFYRAbqUQ2ynkgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_025def9e-de6a-4bc8-ac74-f00d671737a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-540d-773a-a833-8f75d5e801d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-540d-773a-a833-8f75d5e801d8",
        "storage_key": "property/6767906449167256/019f3e9f-540d-773a-a833-8f75d5e801d8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00656?cid=loc_70100656P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16495041474996265144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "61.1358817",
      "poi_longitude": "-149.8385167",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-365-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-3396-701e-a5f3-91e3743c5ec2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-3396-701e-a5f3-91e3743c5ec2",
        "storage_key": "property/6767906449167256/019d022a-3396-701e-a5f3-91e3743c5ec2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQGYP-eZyFYRuOB8uNMo6uQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_20962ba0-1e82-4926-b61a-404c94998a18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8936 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Chain fitness center offering 24-hour access, personal training, and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-14c7-706b-bd53-f5339664780c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-14c7-706b-bd53-f5339664780c",
        "storage_key": "property/6767906449167256/019d022a-14c7-706b-bd53-f5339664780c.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/anchorage-alaska-4023/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4023",
      "poi_directions_map_url": "https://maps.google.com/?cid=15154378622549450527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "61.1397399",
      "poi_longitude": "-149.8351745",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-600-2611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5JjnF6ZyFYRH1_V3BArT9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bc89b082-518b-4562-b364-77dcc118bef4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "The Alaska Club East Gym & Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "5201 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "This fitness center features a swimming pool along with a racquetball court and an indoor tennis court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-148d-7297-a200-d9ffa9bd71a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-148d-7297-a200-d9ffa9bd71a7",
        "storage_key": "property/6767906449167256/019d022a-148d-7297-a200-d9ffa9bd71a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-taceast-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=13441179354482565633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-east-gym--pool",
      "poi_latitude": "61.181272",
      "poi_longitude": "-149.7830598",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-337-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8ujJiCXyFYRAWI_kmipiLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_964a3e82-1095-4d77-822c-1db68ddd0639",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Her Fusion Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "135 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Modern fitness studio offering group classes for women in a welcoming environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-579c-723c-9158-b2302e1a77c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-579c-723c-9158-b2302e1a77c3",
        "storage_key": "property/6767906449167256/019f3e9f-579c-723c-9158-b2302e1a77c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.herfusionfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11232207855282316377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "her-fusion-fitness",
      "poi_latitude": "61.14523479999999",
      "poi_longitude": "-149.8815531",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-602-8111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGaITnmOZyFYRWWR0mYjR4Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_308fcd9f-4a40-4620-8cee-a9a1bd726584",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Studio Pulse Center for Dance + The Annex Yoga & Dance Fitness",
      "poi_type": "Education",
      "poi_address": "2422 E Tudor Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-5554-759f-b37a-bb7857963777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-5554-759f-b37a-bb7857963777",
        "storage_key": "property/6767906449167256/019f3e9f-5554-759f-b37a-bb7857963777.webp",
        "width": 1280,
        "height": 523
      },
      "poi_business_url": "http://www.studiopulseak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11063286012939859337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-pulse-center-for-dance--the-annex-yoga--dance-fitness",
      "poi_latitude": "61.1803623",
      "poi_longitude": "-149.8362386",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-677-8573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2ef0-712a-8ed1-91e5080f83b0",
        "storage_key": "property/6767906449167256/019d022a-2ef0-712a-8ed1-91e5080f83b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi-l9MwiXyFYRifXTUQOwiJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_school"
    },
    {
      "id": "custom_f7fe7dd6-d1eb-45e1-95ad-2b7734bc6175",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Whisper Faith Kovach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1904 Lore Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Large fenced-in dog park featuring two spacious areas, including one specifically for small dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-59e9-707f-a974-fd70467931da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-59e9-707f-a974-fd70467931da",
        "storage_key": "property/6767906449167256/019f3e9f-59e9-707f-a974-fd70467931da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.muni.org/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=10967816348118186924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whisper-faith-kovach-park",
      "poi_latitude": "61.1518118",
      "poi_longitude": "-149.8460985",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2f84-758f-9755-d659c14428d7",
        "storage_key": "property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZKBGmOXyFYRrHtOz9uCNZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5ab657f6-476c-4c7a-ae20-56da3329b54d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "South Anchorage Sports Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "779 W Klatt Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "Recreational area with baseball fields, a playground, and picnic tables, as well as a merry-go-round.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-5872-74e2-ac4a-98374f175651.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-5872-74e2-ac4a-98374f175651",
        "storage_key": "property/6767906449167256/019f3e9f-5872-74e2-ac4a-98374f175651.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14784710653396140022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-anchorage-sports-park",
      "poi_latitude": "61.117003",
      "poi_longitude": "-149.8949243",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2f84-758f-9755-d659c14428d7",
        "storage_key": "property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQOOu6WZyFYR9j-cqgHYLc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_de0ffef8-593a-462b-9738-aee56d5ea773",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Campbell Creek Science Center",
      "poi_type": "Entertainment",
      "poi_address": "5600 Science Center Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "Interactive educational center for kids, with science exhibits and nature treks, plus friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-58e0-7389-89c9-391635a1445a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-58e0-7389-89c9-391635a1445a",
        "storage_key": "property/6767906449167256/019f3e9f-58e0-7389-89c9-391635a1445a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.blm.gov/learn/interpretive-centers/campbell-creek-science-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2738030936295452035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-creek-science-center",
      "poi_latitude": "61.1641914",
      "poi_longitude": "-149.7769605",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-621-4602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2fe8-76ec-9d27-fb186a1dc353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2fe8-76ec-9d27-fb186a1dc353",
        "storage_key": "property/6767906449167256/019d022a-2fe8-76ec-9d27-fb186a1dc353.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxMQgkmXyFYRg63rPaFw_yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f0c9073c-30ea-46e7-9139-e1132b3c96c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Smokejumper Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "BLM Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Wooded hiking route featuring varied terrain, plus wildlife such as moose and bears.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-6029-73eb-ad7a-9d79bf3ca337.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-6029-73eb-ad7a-9d79bf3ca337",
        "storage_key": "property/6767906449167256/019f3e9f-6029-73eb-ad7a-9d79bf3ca337.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8654776823858667500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smokejumper-trailhead",
      "poi_latitude": "61.1587152",
      "poi_longitude": "-149.8009067",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-7177-7398-8f6c-8f4a71839e8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3e9f-7177-7398-8f6c-8f4a71839e8a",
        "storage_key": "property/6767906449167256/019f3e9f-7177-7398-8f6c-8f4a71839e8a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29t51UCXyFYR7B9hlKrxG3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_8b7b3dbe-c010-4f59-afbc-a5cd1126f36d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Far North Bicentennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4970 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Popular 4,000-acre park with 100-plus miles of multi-use trails, skiing, a botanical garden & more.",
      "poi_long_description": "Popular 4,000-acre park with 100-plus miles of multi-use trails, skiing, a botanical garden & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-5efd-7790-ba73-d5db30e07fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-5efd-7790-ba73-d5db30e07fda",
        "storage_key": "property/6767906449167256/019f3e9f-5efd-7790-ba73-d5db30e07fda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1862495611458923156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "far-north-bicentennial-park",
      "poi_latitude": "61.1559064",
      "poi_longitude": "-149.7514649",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2f84-758f-9755-d659c14428d7",
        "storage_key": "property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2OHIzSXyFYRlKq7BOTp2Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6283fcb1-f77e-4d7d-978b-b0b52af838a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Goose Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2811 UAA Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "Park featuring a playground and a lake for swimming, as well as trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-64f7-70aa-a15b-f913b40c1963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-64f7-70aa-a15b-f913b40c1963",
        "storage_key": "property/6767906449167256/019f3e9f-64f7-70aa-a15b-f913b40c1963.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11901590233418431737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goose-lake-park",
      "poi_latitude": "61.1969124",
      "poi_longitude": "-149.820842",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2f84-758f-9755-d659c14428d7",
        "storage_key": "property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzZeSVSWyFYR-fwpjULxKqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4f8dd1a8-a5b7-496d-b138-e2884ac8bd96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Jewel Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4401 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "Lakefront getaway providing a swimming beach, picnic pavilion & children's play equipment.",
      "poi_long_description": "Lakefront getaway providing a swimming beach, picnic pavilion & children's play equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-6093-7262-8a75-6e5fcc22d3ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-6093-7262-8a75-6e5fcc22d3ce",
        "storage_key": "property/6767906449167256/019f3e9f-6093-7262-8a75-6e5fcc22d3ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3912813866064468304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jewel-lake-park",
      "poi_latitude": "61.1411207",
      "poi_longitude": "-149.9595208",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2f84-758f-9755-d659c14428d7",
        "storage_key": "property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-FffG6YyFYRUNn-7nobTTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_06d68b90-d3fc-444c-bd7c-210709483ef9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Balto Seppala Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3360 Wisconsin St, Anchorage, AK 99517, USA",
      "poi_short_description": "City park offering play equipment, picnic tables and a sledding hill.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-5fd5-7136-8df3-009f19e6dfbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-5fd5-7136-8df3-009f19e6dfbd",
        "storage_key": "property/6767906449167256/019f3e9f-5fd5-7136-8df3-009f19e6dfbd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6136051254312274303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "balto-seppala-park",
      "poi_latitude": "61.1903545",
      "poi_longitude": "-149.9441637",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2f84-758f-9755-d659c14428d7",
        "storage_key": "property/6767906449167256/019d022a-2f84-758f-9755-d659c14428d7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06_ffv2XyFYRf4nfCBuiJ1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_a73ebb1e-1d16-473e-ad3d-53f872455066",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-64f4-7270-b5c9-978be2be71aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-64f4-7270-b5c9-978be2be71aa",
        "storage_key": "property/6767906449167256/019f3e9f-64f4-7270-b5c9-978be2be71aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_4ca0543b-8082-4b60-84e3-d301675b5356",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-64f9-7535-9a5f-df9bf9fcd1dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-64f9-7535-9a5f-df9bf9fcd1dd",
        "storage_key": "property/6767906449167256/019f3e9f-64f9-7535-9a5f-df9bf9fcd1dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-7179-70fc-9939-c7654bdd9779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3e9f-7179-70fc-9939-c7654bdd9779",
        "storage_key": "property/6767906449167256/019f3e9f-7179-70fc-9939-c7654bdd9779.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_da8d6ccb-0598-45c7-b2db-a72ab7815e5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-2137-74de-b1eb-b1dea2ab8c4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-2137-74de-b1eb-b1dea2ab8c4d",
        "storage_key": "property/6767906449167256/019f3e9d-2137-74de-b1eb-b1dea2ab8c4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-3458-729b-8e97-184e170ae01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-3458-729b-8e97-184e170ae01e",
        "storage_key": "property/6767906449167256/019d022a-3458-729b-8e97-184e170ae01e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_81a62b22-071b-4317-84bb-7ef4fea89d74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-2207-767a-8d98-cdb7b2fe9910.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-2207-767a-8d98-cdb7b2fe9910",
        "storage_key": "property/6767906449167256/019f3e9d-2207-767a-8d98-cdb7b2fe9910.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.22168490000001",
      "poi_longitude": "-149.8904657",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-33da-704e-8a41-a0e48722830b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-33da-704e-8a41-a0e48722830b",
        "storage_key": "property/6767906449167256/019d022a-33da-704e-8a41-a0e48722830b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e13bb8f9-5eda-4a75-9eaa-92ba7f1718ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Port Of Alaska",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 Anchorage Port Rd, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-66ee-746d-b5ec-5255a5d946ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-66ee-746d-b5ec-5255a5d946ea",
        "storage_key": "property/6767906449167256/019f3e9f-66ee-746d-b5ec-5255a5d946ea.webp",
        "width": 952,
        "height": 984
      },
      "poi_business_url": "http://www.portofalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1615135989646056101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-of-alaska",
      "poi_latitude": "61.2393502",
      "poi_longitude": "-149.8880141",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-343-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-7179-70fc-9939-c7654bdd9779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3e9f-7179-70fc-9939-c7654bdd9779",
        "storage_key": "property/6767906449167256/019f3e9f-7179-70fc-9939-c7654bdd9779.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJORWui_K9yFYRpVrNDqAdahY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_dd4f83e4-c54f-4c15-aab5-eb0d222dfd6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "People Mover",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Doctor M.L.K. Jr Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-67be-722b-be18-204c7bc79476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-67be-722b-be18-204c7bc79476",
        "storage_key": "property/6767906449167256/019f3e9f-67be-722b-be18-204c7bc79476.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14529945198539884947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "people-mover",
      "poi_latitude": "61.17707559999999",
      "poi_longitude": "-149.8139324",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-8402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSp6ChCXyFYRk8nc1Cy8pMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_8018e13b-01d1-4801-9e4c-0e437197042e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Muldoon & Duben NNE",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-699b-7473-8683-f3a8032d0f99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-699b-7473-8683-f3a8032d0f99",
        "storage_key": "property/6767906449167256/019f3e9f-699b-7473-8683-f3a8032d0f99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15105027056038331803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muldoon--duben-nne",
      "poi_latitude": "61.221163",
      "poi_longitude": "-149.733263",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-7179-70fc-9939-c7654bdd9779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3e9f-7179-70fc-9939-c7654bdd9779",
        "storage_key": "property/6767906449167256/019f3e9f-7179-70fc-9939-c7654bdd9779.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJb4wyZ-WyFYRm0XU3RPWn9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_703a105e-2cd9-4e07-b502-fae3a83ea7e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-17ca-724e-b989-29f98e5dde95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-17ca-724e-b989-29f98e5dde95",
        "storage_key": "property/6767906449167256/019f3e9d-17ca-724e-b989-29f98e5dde95.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-3199-758d-bb41-f740a2e3b52f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-3199-758d-bb41-f740a2e3b52f",
        "storage_key": "property/6767906449167256/019d022a-3199-758d-bb41-f740a2e3b52f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_49a3fbc2-2484-4210-975a-8a34cd4a2c6e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Southcentral Foundation Nu ch’ghednu Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Southcentral Foundation Administration Building, 4501 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-6a2d-753b-8269-2b824de4418d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-6a2d-753b-8269-2b824de4418d",
        "storage_key": "property/6767906449167256/019f3e9f-6a2d-753b-8269-2b824de4418d.webp",
        "width": 1022,
        "height": 1280
      },
      "poi_business_url": "https://www.southcentralfoundation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17022574653971337258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southcentral-foundation-nu-chghednu-building",
      "poi_latitude": "61.18234169999999",
      "poi_longitude": "-149.795892",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-729-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYTXMhyXyFYRKpCHVHVVPOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_13d690a4-1a8e-477a-a0f6-21413dce9b8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "JBER Public Affairs",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10480 Sijan Ave, Anchorage, AK 99506, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jber.jb.mil/Services-Resources/Public-Affairs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18373584563523412467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jber-public-affairs",
      "poi_latitude": "61.2471852",
      "poi_longitude": "-149.8093306",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-552-8151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-37d0-73e3-ac9f-f0181dfa67b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-37d0-73e3-ac9f-f0181dfa67b0",
        "storage_key": "property/6767906449167256/019d022a-37d0-73e3-ac9f-f0181dfa67b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVGywKKVyFYR8-FpJ9AV_P4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_95a0a765-f922-462e-a7ac-7e67a805d816",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Alaska Psychiatric Institute",
      "poi_type": "Health and Wellness",
      "poi_address": "3700 Piper St, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-6b8b-754e-b2b2-394ec9a65b42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-6b8b-754e-b2b2-394ec9a65b42",
        "storage_key": "property/6767906449167256/019f3e9f-6b8b-754e-b2b2-394ec9a65b42.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://dfcs.alaska.gov/API/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14395866377751391257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-psychiatric-institute",
      "poi_latitude": "61.1852467",
      "poi_longitude": "-149.8293623",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-269-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF5zgegeXyFYRGWzcrzJkyMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_38437722-188a-42d3-8853-774cc38434eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9d-252b-7293-88e8-bb9390c155c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9d-252b-7293-88e8-bb9390c155c9",
        "storage_key": "property/6767906449167256/019f3e9d-252b-7293-88e8-bb9390c155c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.21632990000001",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-37d0-73e3-ac9f-f0181dfa67b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-37d0-73e3-ac9f-f0181dfa67b0",
        "storage_key": "property/6767906449167256/019d022a-37d0-73e3-ac9f-f0181dfa67b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_6a35cfed-c3b3-40ef-9004-52154f31054d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "poi_name": "CIRI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "725 E Fireweed Ln #800, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f3e9f-6b2d-777a-b48f-66d7e366350d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3e9f-6b2d-777a-b48f-66d7e366350d",
        "storage_key": "property/6767906449167256/019f3e9f-6b2d-777a-b48f-66d7e366350d.webp",
        "width": 1280,
        "height": 1016
      },
      "poi_business_url": "http://www.ciri.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14672288598052404669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ciri",
      "poi_latitude": "61.1990764",
      "poi_longitude": "-149.8696912",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-274-8638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022a-2602-7048-83b4-6aa18b9ab2ad",
        "storage_key": "property/6767906449167256/019d022a-2602-7048-83b4-6aa18b9ab2ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyac4MMqXyFYRvX3tKL5wnss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_710519eaa3eace3c417583dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_eb1534119e74ab178f435cdc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_941c79f68101bc524ee106e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4658e1ed5ad1d047fd53f987",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ccf95cbe9561df74e03ba681",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_ef802795-ba18-43a1-a961-b9cbf789bcf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "rating": "5.0",
      "name": "Debi Shelton",
      "text": "Great place to live. Mark is fantastic, always kind and helpful. Augustin is awesome, fixed our maintenance issue quickly, with a friendly smile.",
      "date": "2025-05-01",
      "title": ""
    },
    {
      "id": "custom_30a61416-1035-4fbd-aa46-510709f40a12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "rating": "5.0",
      "name": "C L",
      "text": "Been a resident for almost a year now! Seamless process to apply/be processed/and move in. For as many apartments and people living here it is a very quiet complex that is very well maintained. Rent is decent and utilities are fair. Mark is an amazing landlord: receptive, friendly, and overall proactive if any needs arise. Only complaint is that we can only show our appreciation for him and his team from a google review. 😊 10/10 have and will continue to recommend",
      "date": "2021-12-16",
      "title": ""
    },
    {
      "id": "custom_a5d05bcc-3afa-45e4-97f9-d770ec2b3a69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "rating": "5.0",
      "name": "Deb Codding",
      "text": "Silver Ridge is a great place to live.  Mark, the manager, is a superstar in my opinion.  He is always concerned about the welfare of everyone who lives here.  He is a true professional in the way he handles every aspect of his job.  His concern for the tenants appears to be the main focus of everything he does.  Maintenance issues are handled quickly.  The manager follows up immediately to ensure that every aspect of the maintenance was handled to the satisfaction of the tenant.  In my 65 years I have never lived anywhere that is as tenant-focused as Silver Ridge.  I would recommend Silver Ridge to anyone without any reservations.",
      "date": "2019-08-06",
      "title": ""
    },
    {
      "id": "custom_8766601f-1d0d-4eef-aa07-3db781b220db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "rating": "5.0",
      "name": "Leilani",
      "text": "This is my second time living at Silver Ridge, and I can say that both times (even though I was just a teenager that first time) living here was a great experience. I have never once had a problem that wasn't remedied fast, and Mark has always been such a great property manager. On top of that, Silver Ridge is a beautiful (and affordable!) place to live.",
      "date": "2021-12-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f755f7ea-9459-4ce0-ba2b-d111a9f5bd23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167256/019f8622-07ad-744e-a01f-fa42bb27ca24.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8622-07ad-744e-a01f-fa42bb27ca24",
        "storage_key": "property/6767906449167256/019f8622-07ad-744e-a01f-fa42bb27ca24.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Silver Ridge   #210  3x2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BwwCNWc1nd4"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f95f3-7897-7168-83e3-c9ad59207c32",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Silver Ridge Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-washer-dryer-anchorage-ak",
      "search_query": "apartments with in-unit washer/dryer anchorage ak",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer/Dryer in Anchorage",
      "h2_subtitle": "Experience the convenience of living in Anchorage apartments with in-unit washer/dryer. Enjoy modern amenities at Silver Ridge today.",
      "page_copy": "Discover the perfect blend of convenience and modern living at Silver Ridge, located in the heart of Anchorage. Our apartments with in-unit washer/dryer ensure you spend less time on chores and more on enjoying life. Nestled in the vibrant Abbott Loop neighborhood, Silver Ridge offers a peaceful retreat with exceptional amenities like a pet play area and a welcoming courtyard.\n\nSilver Ridge is tailored to meet all your residential needs, featuring private patios or balconies and efficient online services to streamline your day-to-day tasks. These thoughtfully designed apartments provide you with a comfortable space featuring in-home washer/dryer units, making laundry a hassle-free experience. Come and be a part of a community where quality and convenience meet, right here in Anchorage, AK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer/Dryer Anchorage",
      "seo_description": "Find Anchorage apartments with in-unit washer/dryer at Silver Ridge. Enjoy modern living with great amenities in the Abbott Loop neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-with-dog-park-anchorage-municipality",
      "search_query": "pet-friendly apartments with dog park in anchorage municipality",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet-friendly apartments in Anchorage Municipality featuring a dog park. Silver Ridge offers everything your pet needs.",
      "page_copy": "Embrace a lifestyle that welcomes both you and your furry friends at Silver Ridge. Located in Anchorage Municipality, our pet-friendly apartments boast a dedicated dog park, perfect for your dog's exercise and socialization. Set within the thriving Abbott Loop neighborhood, Silver Ridge combines comfort with a sense of community.\n\nOur spacious apartments provide all the comforts of home, including a pet play area designed with your pets in mind. With convenient features like in-home washer/dryer units and private patios or balconies, Silver Ridge ensures both you and your pets enjoy a harmonious living environment. Come and see why Silver Ridge is the ideal place for pet lovers in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park Anchorage",
      "seo_description": "Discover pet-friendly apartments with a dog park in Anchorage Municipality at Silver Ridge, offering comfort and convenience for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "generator",
      "page_item_url": "apartments-with-double-vanities-near-abbott-loop",
      "search_query": "apartments with double vanities near abbott loop",
      "category": "Amenity",
      "h1_title": "Apartments with Double Vanities Near Abbott Loop",
      "h2_subtitle": "Find spacious apartments near Abbott Loop featuring double vanities. Silver Ridge offers luxurious living in a prime location.",
      "page_copy": "Silver Ridge, located near the bustling Abbott Loop, offers the perfect balance of style and convenience with our apartments that include double vanities. This feature provides a touch of luxury to your daily routines, making mornings seamless and stress-free. Our community places you at the center of Anchorage's vibrant lifestyle while offering a peaceful residential setting.\n\nBeyond the comfort of double vanities, Silver Ridge apartments are equipped with modern amenities designed to enhance your living experience. Enjoy the expansive courtyard, efficient online services, and in-home washer/dryers. Each apartment extends to a private patio or balcony, ensuring you have ample space to relax. Discover the ideal home at Silver Ridge, where functionality meets elegance near Abbott Loop.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Double Vanities Near Abbott Loop",
      "seo_description": "Explore Silver Ridge apartments near Abbott Loop featuring double vanities, offering luxurious living and convenience in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "generator",
      "page_item_url": "anchorage-apartments-with-gas-fireplace",
      "search_query": "anchorage apartments with gas fireplace",
      "category": "Amenity",
      "h1_title": "Anchorage Apartments with Gas Fireplace",
      "h2_subtitle": "Discover the warmth of Anchorage apartments equipped with a gas fireplace. Silver Ridge offers cozy living with exceptional amenities.",
      "page_copy": "Experience the cozy ambiance of Silver Ridge, where Anchorage apartments come complete with gas fireplaces. Nestled in the charming Abbott Loop neighborhood, our community offers the perfect setting for comfortable living. The gas fireplace not only adds warmth to your home but also enhances its aesthetic appeal, making every evening at home a special occasion.\n\nSilver Ridge prides itself on delivering a comprehensive living experience. Beyond the inviting atmosphere provided by gas fireplaces, our residents enjoy modern conveniences such as in-home washer/dryers and private balconies. Our pet-friendly community also features a pet play area and expansive courtyard, all complemented by our efficient online services. Make Silver Ridge your home and indulge in both comfort and style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Anchorage Apartments with Gas Fireplace",
      "seo_description": "Discover Anchorage apartments at Silver Ridge with gas fireplaces. Enjoy cozy living with modern amenities in the Abbott Loop neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "generator",
      "page_item_url": "apartments-large-closets-balconies-99507",
      "search_query": "apartments with large closets and balconies 99507",
      "category": "Amenity",
      "h1_title": "Apartments with Large Closets and Balconies",
      "h2_subtitle": "Spacious living awaits at Silver Ridge in 99507, featuring apartments with large closets and balconies. Enjoy both storage and outdoor relaxation.",
      "page_copy": "Silver Ridge presents a refined living experience in the 99507 area, highlighted by apartments that boast large closets and expansive balconies. Perfectly situated in Anchorage's Abbott Loop neighborhood, our community combines convenience and ample space to meet your lifestyle needs. Large closets offer plenty of storage, while balconies provide a perfect spot for relaxation and outdoor enjoyment.\n\nAt Silver Ridge, we prioritize comfort and functionality. Each apartment is designed with thoughtful amenities, including in-home washer/dryers and access to a beautiful courtyard, enhancing your daily living. Our pet-friendly community ensures both you and your furry friends feel welcome and at ease. Experience a lifestyle tailored to you at Silver Ridge, where ample storage and serene outdoor spaces are standard.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Large Closets and Balconies 99507",
      "seo_description": "Explore Silver Ridge in Anchorage 99507 offering apartments with large closets and balconies, providing spacious and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167256",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-abbott-loop-anchorage",
      "search_query": "three bedroom apartments abbott loop anchorage",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Abbott Loop",
      "h2_subtitle": "Find spacious three bedroom apartments in Abbott Loop, Anchorage. Silver Ridge offers ample living space with modern amenities.",
      "page_copy": "Silver Ridge invites you to explore our spacious three bedroom apartments in the vibrant neighborhood of Abbott Loop, Anchorage. Designed to accommodate a modern lifestyle, these apartments provide ample room for families, roommates, or those seeking extra space. Each unit is thoughtfully designed with contemporary finishes to ensure comfort and style in every corner.\n\nLiving at Silver Ridge means enjoying not just the spacious interiors but also a suite of amenities that enhance daily living. From in-home washer/dryers and online services to private patios or balconies, every detail is crafted with our residents' needs in mind. The community also features a pet play area and a relaxing courtyard, making it a perfect fit for pet owners and outdoor enthusiasts. Discover a home that supports your lifestyle's needs at Silver Ridge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Abbott Loop, Anchorage",
      "seo_description": "Explore three bedroom apartments in Abbott Loop at Silver Ridge, Anchorage, offering modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309860794"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085505"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KTT3GMCW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "f2b8bfd1-e16c-4e85-994f-6c57b4b46d4b"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/5f022ea0-b89d-4e71-a02a-23bda01eb922/app.js?property=5f022ea0-b89d-4e71-a02a-23bda01eb922&propertyName=Silver+Ridge&channelUuid=c248fe47-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "6341154650"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ijc2MlBZZUtJcE1EOTNneUMrSDhYUkE9PSIsInZhbHVlIjoiL2J1WVJsMVNZVzVTaHQ4bDY3eXFpUT09IiwibWFjIjoiYWQ5YzU2NWY2NjM3MjYyZmIxZTEyY2NjZWIxNzdlODM2MDFhOTI4MzkxMDZmMjZhOWNlZGU5NWNmYWJkYTQ5NSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309860794",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085505",
  "custom_google_gtm_id": "GTM-KTT3GMCW",
  "custom_rollout_phase": "Phase 6",
  "custom_rentgrata_token": "f2b8bfd1-e16c-4e85-994f-6c57b4b46d4b",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/5f022ea0-b89d-4e71-a02a-23bda01eb922/app.js?property=5f022ea0-b89d-4e71-a02a-23bda01eb922&propertyName=Silver+Ridge&channelUuid=c248fe47-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "6341154650",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ijc2MlBZZUtJcE1EOTNneUMrSDhYUkE9PSIsInZhbHVlIjoiL2J1WVJsMVNZVzVTaHQ4bDY3eXFpUT09IiwibWFjIjoiYWQ5YzU2NWY2NjM3MjYyZmIxZTEyY2NjZWIxNzdlODM2MDFhOTI4MzkxMDZmMjZhOWNlZGU5NWNmYWJkYTQ5NSJ9",
  "custom_audioeye_site_id": "f9cb6b8e-1b70-435c-8703-49f100d56883",
  "custom_audioeye_site_hash": "eb7ee5c58a704e82079646e8b7935f2f"
};

export const generatedAt = '2026-10-27T17:00:23.341Z';
